import InstanceApi from "@/services/apiClient.js";
import { mapGetters, mapActions } from "vuex";
import EventBus from "@/event-bus";

export default {
  data() {
    return {
      product: {},
      succeed: false,
    };
  },
  props: {
    productId: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters({ 
      storeUrlPrefix: "getStoreUrlPrefix",
      isRetailable: "getProductIsRetailable",
     }),
  },

  methods: {
    async getProduct(productdatas) {
      try {
        this.product = productdatas;
        this.succeed = true;
        this.setAppProduct(this.product);
        this.setPreprendCartProductId(productdatas.entity_id);
        this.setPreprendCartNeedCartCleaning(this.product.need_cart_cleaning);
        this.setProductUniverse(this.product.mcp_universe);

        //If current cart contains product with standard delivery or url contains ?from=googleshopping
        if ( (this.product.standard_delivery_in_cart || this.product.delivery_only) && this.isRetailable == true) {
          this.setPreprendCartStandardDeliveryInCart(true);
          this.setPreprendCartCurrentSelectedDelivery('delivery_only');
        } else {
          this.setPreprendCartStandardDeliveryInCart(false);
        }

        this.setPreprendCartInstallationProductInCart(this.product.installation_product_in_cart);
        this.setPreprendCartIsExclusive(this.product.is_exclusive);
        this.setTaxProfile(this.product.tax_profile);

        // SET CURRENT INTERVENTION
        let currentIntervention = {};
        Object.values(this.product.shipping_methods).forEach(element => {
          if (!element.current_intervention) return;
          this.setSelectedDeliveryId(element.id)
          this.setCurrentDeliveryId(element.id)
          currentIntervention = {
            interventionProductId: element.current_intervention.mcp_intervention_product,
            agencyId: element.current_intervention.mcp_agency,
            selectedHours: element.current_intervention.mcp_intervention_slot_hour,
            id: element.id,
            selectedDate: element.current_intervention.mcp_intervention_date,
            start: new Date(element.current_intervention.mcp_intervention_date),
            slotId: element.current_intervention.mcp_intervention_slot,
            postalCode: element.current_intervention.mcp_intervention_zipcode,
          };

          //Set times slot selected or updated for countdown
          this.setDateUpdateSlotDelivery(element.current_intervention.mcp_intervention_date_updated_at);
        });

        if(currentIntervention.selectedDate) {
          this.setDelivery(currentIntervention);

          if(currentIntervention.postalCode){
            this.setSelectedDeliveryPostalCode(currentIntervention.postalCode);
          }
            this.setPreprendCartInterventionSlots();
        } 
        
      } catch (error) {
        this.$fire({
          title: "Oups",
          text: "Impossible de charger la pages",
          type: "error",
          footer: '<a href="/">revenir à la page d\'accueil</a>',
          showConfirmButton: false,
        });
      }
    },

    ...mapActions([
      "setAppProduct",
      "setPreprendCartProductId",
      "setPreprendCartNeedCartCleaning",
      "setPreprendCartStandardDeliveryInCart",
      "setPreprendCartInstallationProductInCart",
      "setPreprendCartStandardDeliveryInCart",
      "setPreprendCartIsExclusive",
      "setTaxProfile",
      "setDelivery",
      "setSelectedDeliveryPostalCode",
      "setSelectedDeliveryId",
      "setPreprendCartInterventionSlots",
      "setCurrentDeliveryId",
      "setPreprendCartCurrentSelectedDelivery",
      "setProductUniverse",
      "setDateUpdateSlotDelivery"
    ]),
  },

  async mounted() {
    await EventBus.$on("update-product", id => this.getProduct(id));
  },
};
